import { ResponsiveContainer } from "ui";
import styles from "./css/AboutContainer.module.css";

type Props = {
  children: any;
};

export function AboutContainer({ children }: Props) {
  return (
    <ResponsiveContainer className={styles.container}>
      {children}
    </ResponsiveContainer>
  );
}
